<template>
  <div class="exam-details">
    <el-card>
      <h2>考试情况</h2>

      <!-- 搜索栏 -->
      <el-form :inline="true" class="search-bar" v-if="!showChart">

        <el-form-item>
          <el-select
              v-model="filters.selectedOrganization"
              placeholder="请选择机构"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="organization in organizations"
                :key="organization.organizationID"
                :label="organization.orgName"
                :value="organization.organizationID"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 学员姓名下拉框 -->
        <el-form-item>
          <el-select
              v-model="filters.selectedUser"
              placeholder="请选择学员"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="user in users"
                :key="user.value"
                :label="user.label"
                :value="user.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 培训计划下拉框 -->
        <el-form-item>
          <el-select
              v-model="filters.selectedPlan"
              placeholder="请选择培训计划"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="plan in plans"
                :key="plan.value"
                :label="plan.label"
                :value="plan.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 搜索按钮 -->
        <el-form-item>
          <el-button type="primary" @click="fetchExamDetails">搜索</el-button>
        </el-form-item>

      </el-form>
      <el-button type="primary" @click="toggleChartVisibility">
        {{ showChart ? "隐藏图表" : "显示图表" }}
      </el-button>
      <!-- ECharts 图表组件 -->
      <div v-if="showChart">
        <ChartComponent />
      </div>

      <div v-else>
      <!-- 考试详情表格 -->
      <el-table :data="examDetails.records" border style="width: 100%">
        <el-table-column prop="planName" label="培训计划" width="200"></el-table-column>
        <el-table-column prop="name" label="学员姓名" width="150"></el-table-column>
        <el-table-column prop="score" label="考试分数" width="120"></el-table-column>
        <el-table-column prop="status" label="考试状态" width="120">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '已完成' : '未完成' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="开始时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.startDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="endDate" label="结束时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.endDate) }}
          </template>
        </el-table-column>
      </el-table>




      <!-- 分页 -->
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.size"
          :total="examDetails.total"
          layout="total, prev, pager, next, jumper"
          @current-change="handlePageChange"
      ></el-pagination>
      </div>
    </el-card>
  </div>
</template>
import { ElMessage } from "element-plus";

<script>import axios from "@/axios";
import ChartComponent from "@/components/Super/XY/EchartView1.vue";
export default {
  components: {
    ChartComponent, // 注册图表组件
  },
  data() {
    return {

      showChart: false, // 控制图表显示与否
      examDetails: {
        records: [],
        total: 0,
      }, // 考试详情数据
      filters: {
        selectedUser: null, // 学员 ID
        selectedPlan: null, // 培训计划 ID
        selectedOrganization: null, // 机构 ID
      },
      pagination: {
        page: 1,
        size: 5,
      },
      users: [], // 学员下拉框选项
      plans: [], // 培训计划下拉框选项
      organizations: [], // 机构下拉框选项
    };
  },
  methods: {
    toggleChartVisibility() {
      this.showChart = !this.showChart;
    },
    // 获取考试详情
    fetchExamDetails() {
      const { page, size } = this.pagination;
      const params = {
        userid: this.filters.selectedUser, // 学员 ID
        planid: this.filters.selectedPlan, // 培训计划 ID
        organizationID: this.filters.selectedOrganization, // 机构 ID
        page,
        size,
      };

      axios
          .get("/Exam/details", { params })
          .then((response) => {
            const data = response.data;
            this.examDetails = {
              records: data.data,
              total: data.total,
            };

            // 初次加载时提取学员和培训计划下拉框选项
            // if (!this.filters.selectedUser && !this.filters.selectedPlan) {
              this.extractDropdownOptions(data.data);
            // }
          })
          .catch((error) => {
            console.error("获取考试详情失败:", error);
            this.$message.error("获取考试详情失败！");
          });
    },

    // 提取并去重学员、培训计划和机构选项
    extractDropdownOptions(data) {
      const uniqueUsers = new Set();
      const uniquePlans = new Set();
      const uniqueOrganizations = new Set();

      data.forEach((item) => {
        uniqueUsers.add(item.userId);
        uniquePlans.add(item.training_plan_id);
        uniqueOrganizations.add(item.organizationID);
      });

      this.users = Array.from(uniqueUsers).map((userId) => {
        const user = data.find((item) => item.userId === userId);
        return { label: user.name, value: userId };
      });

      this.plans = Array.from(uniquePlans).map((planId) => {
        const plan = data.find((item) => item.training_plan_id === planId);
        return { label: plan.planName, value: planId };
      });

    },

    // 分页变化时
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.fetchExamDetails();
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d
          .getDate()
          .toString()
          .padStart(2, "0")}`;
    },
  },
  created() {
    this.fetchExamDetails();

    // 获取机构列表
    axios
        .get("/organization/orglist")
        .then((res) => {
          this.organizations = res.data.data;
        })
        .catch(() => {
          ElMessage.error("获取机构列表失败");
        });
  },
};

</script>

<style scoped>
.exam-details {
  padding: 20px;
}
.search-bar {
  margin-bottom: 20px;
}
.exam-container {
  width: 80%;
  margin: auto;
  padding: 20px;
}
</style>
